import { Controller } from "@hotwired/stimulus"

  // Fills competencies, weights, and education level data from a selected job profile.
// Profiles data is embedded as a JSON value on the controller element.
export default class extends Controller {
  static outlets = ["competency-weights"]
  static targets = ["profileSelect", "competencySelect", "educationLevelSelect", "educationLevelWeightSelect"]
  static values = {
    profiles: Object, // { profileId: { competencies: [...], weights: {...}, education_level: "...", education_level_weight: 30 } }
  }

  fill() {
    const profileId = this.profileSelectTarget.value
    const profile = this.profilesValue[profileId]

    if (!profile) {
      this.competencyWeightsOutlet.updateWeights({})
      this._setCompetencies([])
      this._setEducationLevel(null)
      this._setEducationLevelWeight(null)
    } else {
      this.competencyWeightsOutlet.updateWeights(profile.weights || {})
      this._setCompetencies(profile.competencies || [])
      this._setEducationLevel(profile.education_level)
      this._setEducationLevelWeight(profile.education_level_weight)
    }

    // Notify the form controller so it can re-evaluate submit button state
    this.element.dispatchEvent(
      new Event("formStateChanged", { bubbles: true }),
    )
  }

  _setCompetencies(competencies) {
    const select = this.competencySelectTarget
    const tomSelect = select.tomselect

    if (tomSelect) {
      tomSelect.clear(true)
      competencies.forEach((value) => tomSelect.addItem(value, true))
      // Trigger change so competency-weights controller syncs
      select.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  _setEducationLevel(educationLevel) {
    if (!this.hasEducationLevelSelectTarget) return

    const select = this.educationLevelSelectTarget
    const tomSelect = select.tomselect

    if (tomSelect) {
      if (educationLevel) {
        tomSelect.setValue(educationLevel, true)
      } else {
        tomSelect.clear(true)
      }
    }
  }

  _setEducationLevelWeight(weight) {
    if (!this.hasEducationLevelWeightSelectTarget) return

    const select = this.educationLevelWeightSelectTarget
    const tomSelect = select.tomselect

    if (!tomSelect) return

    if (weight) {
      tomSelect.setValue(String(weight), true)
    } else {
      tomSelect.setValue("30", true)
    }
  }
}
